<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
 {{ "bikeshop.shop_setup.card_headers.long_term_payment_config" | translate }}
</span>
    </div>
  </div>

  <div>
    <div *ngIf="RentalConfigForm">
      <div class="row">
        <div class="col-md-12">
          <div class="content">
            <form [formGroup]="RentalConfigForm" (ngSubmit)="saveConfig(RentalConfigForm.value)">

              <div class="row">
                <div class="col-md-12 section-header">
                  {{ 'bikeshop.rentals.long_term_payment_configuration.rules' | translate }}
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-4 label">
                  {{ "bikeshop.rentals.long_term_payment_configuration.allow_long_term_payments" | translate }}
                  :
                </div>
                <div class="col-md-8">
                  <p-inputSwitch formControlName="allowSplitPayments"></p-inputSwitch>
                </div>
              </div>

              <div *ngIf="RentalConfigForm.controls['allowSplitPayments'].value">
                <div class="row margin-top-8">
                  <div class="col-md-4 label"
                       [ngClass]="{'red': RentalConfigForm.controls['allowForRentalsGreaterThan'].invalid}">
                    {{ "bikeshop.rentals.long_term_payment_configuration.enable_for_rental_duration_greater_than" |
                    translate }}:
                  </div>
                  <div class="col-md-1 label">
                    <div class="p-inputgroup">
                      <input type="number" pInputText
                             formControlName="allowForRentalsGreaterThan"/>
                    </div>
                  </div>
                  <div class="col-md-4 label">
                    <div class="radio-container">
                      <p-radioButton name="allowForRentalsGreaterThanUnitTypeID" value="3"
                                     formControlName="allowForRentalsGreaterThanUnitTypeID"
                                     label="{{ (RentalConfigForm.controls['allowForRentalsGreaterThan'].value == 1 ? 'general.week' : 'general.weeks') | translate }}"></p-radioButton>
                      <p-radioButton name="allowForRentalsGreaterThanUnitTypeID" value="4"
                                     formControlName="allowForRentalsGreaterThanUnitTypeID"
                                     label="{{ (RentalConfigForm.controls['allowForRentalsGreaterThan'].value == 1 ? 'general.month' : 'general.months') | translate }}"></p-radioButton>
                    </div>
                  </div>
                </div>

                <div class="row margin-top-8">
                  <div class="col-md-4 label"
                       [ngClass]="{'red': RentalConfigForm.controls['paymentFrequency'].invalid}">
                    {{ "bikeshop.rentals.long_term_payment_configuration.payment_frequency" | translate }}
                    :
                  </div>
                  <div class="col-md-1 label">
                    <div class="p-inputgroup">
                      <input type="number" pInputText formControlName="paymentFrequency"/>
                    </div>
                  </div>
                  <div class="col-md-4 label">
                    <div class="radio-container">
                      <p-radioButton name="paymentFrequencyUnitTypeID" value="3"
                                     formControlName="paymentFrequencyUnitTypeID"
                                     label="{{ (RentalConfigForm.controls['paymentFrequency'].value == 1 ? 'general.week' : 'general.weeks') | translate }}"></p-radioButton>
                      <p-radioButton name="paymentFrequencyUnitTypeID" value="4"
                                     formControlName="paymentFrequencyUnitTypeID"
                                     label="{{ (RentalConfigForm.controls['paymentFrequency'].value == 1 ? 'general.month' : 'general.months') | translate }}"></p-radioButton>
                    </div>
                  </div>
                </div>

                <div class="row margin-top-8">
                  <div class="col-md-4 label">
                    {{ "bikeshop.rentals.long_term_payment_configuration.bill_on_first_of_next_billing_cycle" |
                    translate }}:
                  </div>
                  <div class="col-md-8">
                    <p-inputSwitch formControlName="billOnFirstOfNextBillingCycle"></p-inputSwitch>
                  </div>
                </div>


                <!-- <div class="row margin-top-8">
                  <div class="col-md-4 label">
                    {{ "bikeshop.rentals.long_term_payment_configuration.first_payment_as_deposit" | translate }}:
                  </div>
                  <div class="col-md-8">
                    <p-inputSwitch formControlName="firstPaymentCollectedAsDeposit"></p-inputSwitch>
                  </div>
                </div> -->


                <div class="row margin-top-8">
                  <div class="col-md-4 label"
                       [ngClass]="{'red': RentalConfigForm.controls['minimumInitialPayment'].invalid}">
                    {{ "bikeshop.rentals.long_term_payment_configuration.minimum_initial_payment" | translate }}
                    :
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>{{partner.CurrencySymbol}}</i></span>
                      <input type="number" pInputText formControlName="minimumInitialPayment"/>
                    </div>
                  </div>
                </div>

                <div class="row margin-top-8">
                  <div class="col-md-4 label">
                    {{ "bikeshop.rentals.long_term_payment_configuration.allow_full_payment" |
                    translate }}:
                  </div>
                  <div class="col-md-8">
                    <p-inputSwitch formControlName="allowFullPayment"></p-inputSwitch>
                  </div>
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-9"></div>
                <div class="col-md-3">
                  <button type="submit" class="iso-round-button full-width"
                          [disabled]="!RentalConfigForm.valid || busy">{{
                    'bikeshop.rentals.configuration.update_configuration' | translate
                    }}</button>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast position="bottom-right"></p-toast>
